<template>
  <div class="intern-only-message">
    <el-card
      shadow="hover"
      :body-style="{ padding: '18px 18px 20px' }"
      class="intern-only-card"
    >
      <div slot="header"
           class="intern-only-header">
        <i class="el-icon-warning-outline"></i>
        <span>访问限制</span>
      </div>

      <div class="intern-only-content">
        <div class="intern-only-title">此页面仅实习生可操作</div>
        <div class="intern-only-desc">请直接到“任务管理-工单管理”进行审单</div>

        <el-button
          type="primary"
          class="intern-only-btn"
          @click="redirectToOrderTable"
        >跳转到工单列表</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'InternOnlyAccessRedirectCard',
  methods: {
    redirectToOrderTable () {
      this.$router.push({
        path: '/order/table',
      })
    },
  },
}
</script>

<style lang="scss"
       scoped>
.intern-only-message {
  margin-top: 18px;
}

.intern-only-card {
  border-radius: 12px;
  background: #f6f8ff;
  border: 1px solid #e1e8ff;
}

.intern-only-header {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  color: #303133;
  font-size: 14px;
}

.intern-only-content {
  padding-top: 2px;
}

.intern-only-title {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 6px;
}

.intern-only-desc {
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
  margin-bottom: 16px;
}

.intern-only-btn {
  font-weight: 600;
}
</style>




// WEBPACK FOOTER //
// src/components/InternOnlyAccessRedirectCard.vue